import { Link } from 'react-router-dom'
import { useAuth } from '@astro/auth'

export default function AccountDropdown({ open, onNavigate }) {
  const { status, user, login, logout } = useAuth()
  const authed = status === 'authenticated'

  return (
    <div
      className={`${open ? '' : 'hidden'} header-dropdown absolute right-0 mt-3 w-64 bg-astroDeep/95 backdrop-blur-2xl border border-white/10 rounded-2xl p-4 shadow-2xl space-y-3 z-50 text-left`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="border-b border-white/10 pb-3 flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-goldGlow/40 border border-goldPrimary/30 flex items-center justify-center text-goldPrimary font-bold text-xs">ॐ</div>
        <div>
          <p className="text-xs font-semibold text-white">{authed && user ? user.name : 'Seeker Portal'}</p>
          <p className="text-[9px] text-white/40">{authed && user ? user.email : 'seeker@astroraju.com'}</p>
        </div>
      </div>
      <div className="space-y-1">
        <Link
          to="/dashboard"
          className="flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-white/5 text-xs text-white/80 hover:text-goldPrimary transition-all"
          onClick={() => onNavigate?.()}
        >
          <span className="text-sm">👤</span> Profile Dashboard
        </Link>
        {authed ? (
          <button
            type="button"
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-red-500/10 text-xs text-red-400 transition-all"
            onClick={() => {
              onNavigate?.()
              logout()
            }}
          >
            <span className="text-sm">🚪</span> Exit Vault (Logout)
          </button>
        ) : (
          <button
            type="button"
            className="w-full flex items-center gap-2.5 px-3 py-2 rounded-xl hover:bg-white/5 text-xs text-white/80 hover:text-goldPrimary transition-all"
            onClick={() => {
              onNavigate?.()
              login()
            }}
          >
            <span className="text-sm">🔑</span> Access Portal (Login)
          </button>
        )}
      </div>
    </div>
  )
}
